import { Switch } from "@headlessui/react";

type ToggleProps = {
  checked: boolean;
  onChange: (next: boolean) => void;
  /** Read out by screen readers; the visible text is the SettingRow label next to it. */
  label: string;
  disabled?: boolean;
};

export function Toggle({ checked, onChange, label, disabled }: ToggleProps) {
  return (
    <Switch
      checked={checked}
      onChange={onChange}
      disabled={disabled}
      aria-label={label}
      className="group relative inline-flex h-6 w-11 shrink-0 cursor-pointer items-center rounded-full bg-gray-200 transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-indigo-500 focus-visible:ring-offset-2 data-[checked]:bg-indigo-600 data-[disabled]:cursor-not-allowed data-[disabled]:opacity-50 max-md:after:absolute max-md:after:-inset-x-2 max-md:after:-inset-y-2.5"
    >
      <span className="inline-block size-[18px] translate-x-[3px] rounded-full bg-white transition-transform group-data-[checked]:translate-x-[23px]" />
    </Switch>
  );
}
